import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsule61 {
  SUBSCRIPTIONS_CAPSULE_61 = PageId.SUBSCRIPTIONS_CAPSULE_61,
  SUB_UPSELL_CAPSULE_61 = PageId.SUB_UPSELL_CAPSULE_61,
  FACE_STYLING_PDF_UPSELL_CAPSULE_61 = PageId.FACE_STYLING_PDF_UPSELL_CAPSULE_61,
  PROPORTIONS_PDF_UPSELL_CAPSULE_61 = PageId.PROPORTIONS_PDF_UPSELL_CAPSULE_61,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE_61 = PageId.DOWNLOAD_CAPSULE_61,
}
